import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
} from '@angular/core';
import { UtilityService } from '@shared/services/utility.service';
import { filter, Subscription, throttleTime } from 'rxjs';

@Directive({
  selector: '[gstarDropDownAppkitOverlayListFix]',
  standalone: true,
})
export class DropDownAppkitOverlayListFixDirective
  implements AfterViewInit, OnDestroy
{
  private readonly el = inject(ElementRef);
  private readonly utilities = inject(UtilityService);
  private isListOpen = false;
  private sub!: Subscription;

  @HostListener('click') onClick(): void {
    this.isListOpen = true;
  }

  ngAfterViewInit(): void {
    this.sub = this.utilities.mainContentScroll$
      .pipe(
        throttleTime(800),
        filter(() => this.isListOpen)
      )
      .subscribe((_event: Event) => {
        const dropdownEl = this.el.nativeElement as HTMLDivElement;
        dropdownEl.parentElement?.parentElement?.click();
        this.isListOpen = false;
      });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
